/*import {Button, Modal, Form} from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";

function RequestPriceModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            data-bs-theme="dark"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter" className="text-light-emphasis">
                    Запрос цены<br/>
                    <span className="text-body-secondary fs-6">{props.productItem?.name || "Товар не указан"}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <InputGroup.Text>Ф.И.О.</InputGroup.Text>
                    <Form.Control
                        required
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        style={{ outline: 'none', boxShadow: 'none',  border: 'var(--bs-border-width) solid var(--bs-border-color)' }}
                    />
                </InputGroup>
                <InputGroup className="mb-3">
                    <InputGroup.Text>Телефон</InputGroup.Text>
                    <Form.Control
                        required
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        style={{ outline: 'none', boxShadow: 'none',  border: 'var(--bs-border-width) solid var(--bs-border-color)' }}
                    />
                </InputGroup>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button onClick={props.onHide} variant="success" className="rounded-4">Отправить</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RequestPriceModal;*/

import {Button, Modal, Form} from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import {useState} from "react";
import {sendTelegramMessage} from "../http/userAPI"; // допустим, этот метод у вас уже есть
import { toast } from "react-toastify";


function RequestPriceModal(props) {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!name || !phone) return alert("Пожалуйста, заполните все поля");

        const message = `
📦 Запрос цены:
🛒 Товар: ${props.productItem?.name || 'Не указан'}
👤 Имя: ${name}
📞 Телефон: ${phone}
        `.trim();

        try {
            setLoading(true);
            await sendTelegramMessage(message); // этот метод должен быть реализован на бэке
            toast.success("Запрос отправлен! Ожидайте, с Вами скоро свяжутся!");
            props.onHide();
            setName('');
            setPhone('');
        } catch (e) {
            alert("Ошибка при отправке сообщения");
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            {...props}
            size="lg"
            data-bs-theme="dark"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter" className="text-light-emphasis">
                    Запрос цены<br/>
                    <span className="text-body-secondary fs-6">{props.productItem?.name || "Товар не указан"}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <InputGroup.Text>Ф.И.О.</InputGroup.Text>
                    <Form.Control
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        style={{ outline: 'none', boxShadow: 'none',  border: 'var(--bs-border-width) solid var(--bs-border-color)' }}
                    />
                </InputGroup>
                <InputGroup className="mb-3">
                    <InputGroup.Text>Телефон</InputGroup.Text>
                    <Form.Control
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        style={{ outline: 'none', boxShadow: 'none',  border: 'var(--bs-border-width) solid var(--bs-border-color)' }}
                    />
                </InputGroup>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button onClick={handleSubmit} variant="success" className="rounded-4" disabled={loading}>{loading ? "Отправка..." : "Отправить"}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RequestPriceModal;
